import { render, staticRenderFns } from "./PreviewGoodsSection.vue?vue&type=template&id=398bd85a&scoped=true"
import script from "./PreviewGoodsSection.vue?vue&type=script&lang=ts"
export * from "./PreviewGoodsSection.vue?vue&type=script&lang=ts"
import style0 from "./PreviewGoodsSection.vue?vue&type=style&index=0&id=398bd85a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398bd85a",
  null
  
)

export default component.exports